import i18nFactory from '@yandex-int/i18n';

import {
    DealsCacheKeysDict,
    DealsSourceParams,
    dealStatusForFilter
} from '../../typings/deals';
import { DealType } from '../../typings/graphql-grid';

import * as keyset from './DealsHelpers.i18n';

const i18n = i18nFactory(keyset);

/**
 * Возвращает название для статуса кампании по его типу
 */
export function getDealStatusByStatusType(
    statusType: dealStatusForFilter
): string {
    const dictionary = {
        [dealStatusForFilter.ARCHIVED]: i18n('archived'),
        [dealStatusForFilter.ACTIVE]: i18n('active'),
        [dealStatusForFilter.COMPLETED_BY_CLIENT]: i18n('completed-by-client'),
        [dealStatusForFilter.COMPLETED_BY_PUBLISHER]: i18n(
            'completed-by-publisher'
        ),
        [dealStatusForFilter.COMPLETED_BY_DATE]: i18n('completed-by-date'),
        [dealStatusForFilter.RECEIVED]: i18n('received')
    };

    if (!dictionary[statusType]) {
        throw new Error(
            `Для сделки со статусом ${statusType} не определен текст статуса`
        );
    }

    return dictionary[statusType];
}

export function getDealTypeTitleByType(type: DealType): string {
    const dictionary = {
        [DealType.PREFERRED_DEAL]: i18n('preferred-deal'),
        [DealType.PRIVATE_MARKETPLACE]: i18n('private_marketplace')
    };

    if (!dictionary[type]) {
        throw new Error(
            `Для сделки с типом ${type} не определен текст типа сделки`
        );
    }

    return dictionary[type];
}

export const addDealsCacheKeyToDict = (
    dict: DealsCacheKeysDict,
    key: string,
    sourceParams?: DealsSourceParams
): DealsCacheKeysDict => {
    const dictLimit = 100;

    // стареющее хранилище кеширующих ключей,
    // при превышении взятого с потолка лимита начинает удалять самые старые записи
    if (sourceParams) {
        dict.set(JSON.stringify(sourceParams), key);

        if (dict.size > dictLimit) {
            const oldestDictKey = dict.keys().next().value;
            dict.delete(oldestDictKey);
        }
    }

    return dict;
};

export const resetDealsCacheKeysDict = (
    dict: DealsCacheKeysDict
): DealsCacheKeysDict => {
    dict.clear();

    return dict;
};
